import { Attribute, Directive, ElementRef, Inject, Input, OnInit, Optional, Renderer2 } from '@angular/core';
import { UI_UX_INPUT_NUMBER_PROVIDER } from '@shared/ui-ux-components/ui-ux-components.config';

/**
 * Directive to provide default properties for input number components.
 */
@Directive({
  selector: 'cwc-input-number',
})
export class UiUxInputNumberProviderDirective implements OnInit {
  constructor(
    private rdr2: Renderer2,
    private host: ElementRef,
    @Optional() @Attribute('hide-unit-on-focus') private hideUnitOnFocusAttribute?: boolean,
    @Optional() @Attribute('design-version') private designVersionAttribute?: string,
    @Optional() @Inject(UI_UX_INPUT_NUMBER_PROVIDER) private configProvider?: any, // Config provider for input number
  ) {
    if (hideUnitOnFocusAttribute || designVersionAttribute) {
      console.warn(
        '☸ For better performance, dynamic updates, type safety, and code consistency, please prefer using property binding.',
      );
    }
  }

  @Input()
  public hideUnitOnFocus!: boolean;

  @Input()
  public designVersion!: string;

  public ngOnInit() {
    // Set properties on the host element based on the inputs, attributes or config provider
    // This allows dynamic updates and ensures that the component behaves as expected by default in specific modules
    const designVersion =
      this.designVersion || this.designVersionAttribute || (this.configProvider && this.configProvider?.designVersion);

    // Define hideUnitOnFocus based on input, attribute, or config provider
    const hideUnitOnFocus =
      this.hideUnitOnFocus !== undefined
        ? this.hideUnitOnFocus
        : this.hideUnitOnFocusAttribute !== undefined && this.hideUnitOnFocusAttribute !== null
          ? this.hideUnitOnFocusAttribute
          : this.configProvider?.hideUnitOnFocus;

    if (designVersion) {
      this.rdr2.setProperty(this.host.nativeElement, 'designVersion', designVersion);
    }
    if (hideUnitOnFocus) {
      this.rdr2.setProperty(this.host.nativeElement, 'hideUnitOnFocus', hideUnitOnFocus);
    }
  }
}
